import React, { Component } from 'react';
import './ProgressBar.css';
import classnames from 'classnames';


class ProgressBar extends Component {

  render() {
    const {
      status,
    } = this.props;

    return (
      <div className="project-progress">
        <div className="project-progress--line"></div>
        <div className={`project-progress--circle 
          ${classnames({ 
            'project-progress--circle__completed': status >= 1, 
            'project-progress--circle__active': status === 0,
            'project-progress--circle__inactive': status < 0,
          })}
        `}>
          1
        </div>
        <div className={`project-progress--circle 
          ${classnames({ 
            'project-progress--circle__completed': status >= 2, 
            'project-progress--circle__active': status === 1,
            'project-progress--circle__inactive': status < 1,
          })}
        `}>
          2
        </div>
        <div className={`project-progress--circle 
          ${classnames({ 
            'project-progress--circle__completed': status >= 3, 
            'project-progress--circle__active': status === 2,
            'project-progress--circle__inactive': status < 2,
          })}
        `}>
          3
        </div>
      </div>
    );
  }
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/ProgressBar.js